function CheckedIcon() {
  return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M6 0C2.68629 0 0 2.68629 0 6V12C0 15.3137 2.68629 18 6 18H12C15.3137 18 18 15.3137 18 12V6C18 2.68629 15.3137 0 12 0H6ZM14.5348 6.67829C14.9094 6.27246 14.8841 5.63981 14.4783 5.2652C14.0725 4.8906 13.4398 4.9159 13.0652 5.32172L7.80445 11.0209L4.73888 7.65949C4.36672 7.25142 3.73422 7.22231 3.32616 7.59447C2.91809 7.96663 2.88898 8.59912 3.26114 9.00719L7.06114 13.1739C7.24991 13.3808 7.51686 13.4992 7.797 13.5C8.07714 13.5008 8.34479 13.3841 8.53481 13.1783L14.5348 6.67829Z"
                  fill="#464B50"/>
        </svg>
  );
}

export default CheckedIcon;
